import BaseModel from "./BaseModel";

export type SessionRatingLevels = "unset" | "bad" | "neutral" | "good";
export type SessionRaterTypes = "Student" | "Tutor";

export default class SessionRatingModel extends BaseModel {
  comprehensionLevel: SessionRatingLevels;
  connectionQuality: SessionRatingLevels;
  tutorPerformance: SessionRatingLevels;
  raterId: number;
  sessionId: number;
  raterType: SessionRaterTypes;

  constructor(arg: any) {
    super(arg);
    this.comprehensionLevel = arg.comprehension_level;
    this.connectionQuality = arg.connection_quality;
    this.tutorPerformance = arg.tutor_performance;
    this.raterType = arg.rater_type;
    this.raterId = arg.rater_id;
    this.sessionId = arg.session_id;
  }

  get isTutorRater(): boolean {
    return this.raterType === "Tutor";
  }

  get isStudentRater(): boolean {
    return this.raterType === "Student";
  }
}
